import { Link } from 'react-router-dom';
import { getFeaturedArticles } from '@/mocks/articles';

export default function FeaturedArticles() {
  const featured = getFeaturedArticles();

  return (
    <section className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between mb-10 md:mb-14 gap-3">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900">
              精选文章
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              精心挑选的深度内容，助你系统掌握色彩设计
            </p>
          </div>
          <Link
            to="/category/color-schemes"
            className="inline-flex items-center gap-1.5 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {featured.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-200 overflow-hidden transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className="relative w-full h-44 md:h-48 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-4 md:p-5 flex flex-col flex-1">
                <div className="flex items-center gap-2 mb-2 flex-wrap">
                  <span className="text-xs px-2 py-0.5 bg-secondary-100 text-secondary-700 rounded-full font-medium">
                    {article.category === 'color-schemes' ? '配色方案' :
                     article.category === 'design-tips' ? '设计技巧' :
                     article.category === 'case-studies' ? '案例分析' :
                     article.category === 'industry-trends' ? '行业趋势' : '工具资源'}
                  </span>
                  <span className="text-xs text-foreground-500">{article.readTime}</span>
                </div>
                <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors duration-200 line-clamp-2 leading-snug">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-3 flex-1">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between mt-auto pt-3 border-t border-background-200/70">
                  <span className="text-xs text-foreground-500">{article.author}</span>
                  <span className="text-xs text-foreground-400">{article.date}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}